import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (user && user !== false) {
    const qsNext = new URLSearchParams(location.search).get("next");
    const to = qsNext || location.state?.from?.pathname || "/";
    return <Navigate to={to} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) setError(res.error);
    else {
      const qsNext = new URLSearchParams(location.search).get("next");
      navigate(qsNext || "/");
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-5" data-testid="login-page">
      {/* Left: Hero */}
      <div className="hidden lg:flex lg:col-span-3 relative bg-black text-white overflow-hidden">
        <div
          className="absolute inset-0 opacity-50"
          style={{
            backgroundImage: "url(https://images.unsplash.com/photo-1612725118809-0bebfb71a551?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBoZWxtZXR8ZW58MHx8fHwxNzc2OTMxMzY1fDA&ixlib=rb-4.1.0&q=85)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "grayscale(1) contrast(1.1)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-black/60 to-transparent" />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="flex items-center gap-3">
            <img src="/logo-union.png" alt="Union" className="h-14 w-auto object-contain rounded-xl" />
            <div>
              <div className="font-bold text-xl" >UNION CHECK</div>
              <div className="tag-label text-[#ff5a00]">SICURI SEMPER</div>
            </div>
          </div>
          <div>
            <div className="tag-label text-[#ff5a00] mb-3">SAFETY · CONFORMITÀ · TRACCIABILITÀ</div>
            <h1 className="text-5xl lg:text-6xl font-bold leading-[0.95] mb-5 text-white" >
              Ispeziona.<br />
              Registra.<br />
              <span className="text-[#ff5a00]">Metti in sicurezza.</span>
            </h1>
          </div>
          <div className="text-xs text-white/60 font-mono">
            Gruppo Union · Via Lorenzo Tabellione, 13 · info@union.sm · 0549 942 493
          </div>
        </div>
      </div>

      {/* Right: Form */}
      <div className="col-span-2 lg:col-span-2 flex items-center justify-center p-6 lg:p-12 bg-white">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-6">
            <img src="/logo-union.png" alt="Union" className="h-11 w-auto object-contain rounded-lg" />
            <div>
              <div className="font-bold text-xl leading-tight" >UNION CHECK</div>
              <div className="tag-label text-[#ff5a00]">SICURI SEMPER</div>
            </div>
          </div>
          <h2 className="text-4xl font-bold mb-8" >
            Accedi al <span className="text-[#ff5a00]">sistema</span>
          </h2>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="bru-label">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bru-input"
                placeholder="nome@azienda.it"
                data-testid="login-email-input"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="bru-label">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bru-input"
                placeholder="••••••••"
                data-testid="login-password-input"
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="border-[1.5px] border-black bg-[#ff3b30] text-white px-3 py-2 text-sm" data-testid="login-error">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="bru-btn bru-btn-primary w-full disabled:opacity-60"
              data-testid="login-submit-button"
            >
              {loading ? "ACCESSO…" : "ENTRA"}
            </button>
          </form>

          <div className="mt-10 border-t-[1.5px] border-black pt-4">
            <div className="tag-label mb-1">ACCESSO RISERVATO</div>
            <p className="text-xs text-neutral-600">
              Se sei un cliente e non hai ancora le credenziali, contatta il tuo responsabile sicurezza.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
